import Axios from "axios";
import { downloadFile } from "./fileDownloader";

export function isSignatureAvailable(personId) {
    return Promise.resolve(false);
    // the code below will be used once pactsafe gets properly defined
    // return Axios.get(`/api/contractconsent/issignatureavailable/${personId}`).then(data => {
    //     return data.data.isSignatureAvailable;
    // });
}

export function downloadContract() {
    downloadFile(`api/contractconsent/downloadcontract`, null, false, "CoverMe_Contract.pdf");
}

export function getEffectiveContractConsent(interview) {
    const contractConsent = interview?.entry?.isResponsiblePartyDifferentFromPatient
        ? interview?.entry?.responsibleParty.contractConsent
        : interview?.entry?.patient.contractConsent;
    return contractConsent;
}

export function getContractSignerPersonId(interview, person) {
    return interview?.entry?.isResponsiblePartyDifferentFromPatient
        ? person?.data[interview.entry.responsibleParty.personId]?.globalId
        : person?.data[interview.entry.patient.personId]?.globalId;
}

export function shouldShowContractConsent(interview) {
    // hiding the section overall till pactsafe module gets on a better shape
    return false;
    // the code below will be used once pactsafe gets properly defined
    // let shouldShow = false;
    // if (interview.coverage.hasCoverage == undefined) {
    //     // the interview has just started, so, show it
    //     shouldShow = true;
    // }
    // return shouldShow && interview.encounterSource !== "Ocr";
}
